// extracted by mini-css-extract-plugin
export default {"switch":"Form-Switch__switch--pu7QB"};